module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-tit"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("During the years of the Civil War, Colorado was embroiled in its own battle: the struggle between the increasing waves of white settlers and the tribes who lived in the region. Both sides were deeply divided within themselves—some worked tirelessly to find a way to coexist peacefully; others wanted total war. At a moment when the peacemakers thought they had found a way forward, those who preferred the violent solution intervened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These are the stories of fourteen people whose lives intersected over the most infamous event in Colorado history: the massacre of Cheyenne and Arapaho Indians at Sand Creek.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b118d9e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/introduction.vue
// module id = 78
// module chunks = 0